<template>
  <div class="drawer">
    <el-drawer size="95%" :visible.sync="drawerStatus" @close="handleClose">
      <div slot="title">
        <span v-if="userInfo._id" style="margin-right: 100px"
          >顾客：{{ userInfo.basic_info.nick_name }}</span
        >
        <span v-if="userInfo._id" style="margin-right: 100px"
          >宠物：{{ curPetInfo.nick_name }}({{
            curPetInfo.category_info.name
          }})</span
        >
        <span v-if="userInfo._id">
          宠物体重：
          <span style="color: red">( {{ petWeight }} kg )</span>
        </span>
      </div>
      <div class="tableBox" ref="tableBox">
        <el-table
          :data="tableData"
          height="396px"
          style="width: 100%"
          size="mini"
          header-cell-class-name="tableHeader"
        >
          <el-table-column label="项目">
            <template slot-scope="scope">
              {{ scope.row.title }} {{ scope.row.skuItem.extend_attr }}
              {{ scope.row.skuItem.service_objectName }}
            </template>
          </el-table-column>
          <el-table-column prop="customCode" label="洗美卡">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.cardId"
                @change="changeCardId(scope.row, scope.$index)"
                placeholder="请选择"
                size="mini"
                style="width: 140px"
                :disabled="scope.row.serviceId === $util.diffItemId"
                clearable
              >
                <el-option
                  v-for="item in scope.row.cardList"
                  :key="item.card_number"
                  :label="
                    item.card_name +
                    '(' +
                    item.service_name +
                    ' ' +
                    item.service_object_name +
                    ')'
                  "
                  :value="item.card_number"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="活动">
            <template slot-scope="scope">
              <el-select
                :disabled="
                  !$public.isNull(scope.row.cardId) ||
                  scope.row.serviceId === $util.diffItemId
                "
                v-model="scope.row.activityId"
                @change="changeActivityId(scope.row, scope.$index)"
                placeholder="请选择"
                size="mini"
                style="width: 160px"
                clearable
              >
                <el-option
                  v-for="item in scope.row.activityList"
                  :key="item._id"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="小计">
            <template slot-scope="scope">
              <div v-if="scope.row.serviceId === $util.diffItemId">
                <el-input
                  v-model="scope.row.skuItem.price"
                  @input="changeNum(scope.row)"
                  size="mini"
                ></el-input>
              </div>
              <div v-else>
                {{ scope.row.skuItem.price }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="销售人员">
            <template slot-scope="scope">
              <el-select
                v-model="scope.row.salesMans"
                @change="changeSaleManIdList(scope.row, scope.$index)"
                multiple
                filterable
                placeholder="请选择"
                size="mini"
                style="width: 110px"
              >
                <el-option
                  v-for="item in staffList"
                  :key="item._id"
                  :label="item.basic_info.nick_name"
                  :value="item._id + ',' + item.basic_info.nick_name"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="delService(scope.row, scope.$index)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-row style="padding: 12px">
          <el-col :span="10">
            <span class="label">备注：</span>
            <span class="value">
              <el-input
                type="textarea"
                v-model="remark"
                @input="changeRemark"
                rows="2"
                style="width: 240px; vertical-align: text-top"
                size="mini"
              ></el-input>
            </span>
          </el-col>
          <el-col :span="4" :offset="10">
            <el-button
              type="warning"
              size="mini"
              @click="drwaerXimeiSelectedService_state = true"
              style="margin-right: 20px"
              >添加服务</el-button
            >
            <el-button type="warning" size="mini" @click="addDiffItem"
              >添加补差价</el-button
            >
          </el-col>
        </el-row>
      </div>
      <div style="position: absolute; width: 100%; bottom: 0">
        <drawerSalesXimeiSettlement
          @submit="complete"
        ></drawerSalesXimeiSettlement>
      </div>
    </el-drawer>
    <div v-if="drwaerXimeiSelectedService_state">
      <ximeiSelectedService
        @closeOn="drwaerXimeiSelectedService_state = false"
        :curPetItem="{
          tableData: tableData,
          petItem: curPetInfo,
          weight: petWeight,
        }"
        @submit="submit_drwaerXimeiSelectedService"
      ></ximeiSelectedService>
    </div>
    <!-- 赠品 -->
    <!-- <div v-if="drawerGift_state">
			<setGift :giveGoods="giveGoods" @submit="submit_drawerGift"></setGift>
		</div> -->
  </div>
</template>

<script>
import ximeiSelectedService from "../../views/mendian/shouyin/drawer/ximeiSelectedService.vue";
import drawerSalesXimeiSettlement from "./drawer_salesXimei_settlement.vue";
// import setGift from "../drawer/setGift.vue"
export default {
  components: { ximeiSelectedService, drawerSalesXimeiSettlement },
  data() {
    return {
      drawerStatus: false,

      tableData: [], // 全等于saleList

      // 添加服务弹窗
      drwaerXimeiSelectedService_state: false,
      // 所有洗美卡
      allCardList: [],

      // 销售人员列表
      staffList: [],

      remark: "",

      // 赠品
      // drawerGift_state:false,
      // giveGoods:{},
      // giftTableData:[],
      // goodsTableData:[],
      // 关联商品
      // useGoods:{},
    };
  },
  computed: {
    curShopId() {
      return this.$store.state.shopId;
    },
    curDiscountCard() {
      return this.$store.state.jiyangguanli.curDiscountCard;
    },
    petWeight() {
      return this.$store.state.jiyangguanli.petWeight;
    },
    userInfo() {
      return this.$store.state.jiyangguanli.userInfo;
    },
    curPetInfo() {
      return this.$store.state.jiyangguanli.curPetInfo;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.drawerStatus = true;
    });
    this.getAllCardsList();
    this.$store.commit("jiyangguanli/set_ximeiList", []);
    this.$store.commit("jiyangguanli/set_curDiscountCard", null);
    this.$store.commit("jiyangguanli/set_remark", "");
    this.$store.commit("jiyangguanli/set_ximeiRemark", "");
    this.$store.commit("jiyangguanli/set_saleTotal", { total: 0, activity: 0 });
    this.getStaffList();
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.$emit("submit", { type: "close" });
    },
    // 生成订单
    complete(obj) {
      if (obj.type === "success") {
        this.$emit("submit", { type: "success" });
      }
    },
    // 添加洗美服务
    submit_drwaerXimeiSelectedService(obj) {
      let list = JSON.parse(obj).list;
      for (let i = 0; i < list.length; i++) {
        if (this.$public.isNull(list[i].skuItem.originalPrice)) {
          list[i].skuItem.originalPrice = list[i].skuItem.price;
        }
        if (this.$public.isNull(list[i].card)) {
          let cardList = this.getCardCanUsed(this.curPetInfo._id, list[i]);
          list[i].cardList = cardList;
          if (cardList.length > 0) {
            list[i].cardId = cardList[0].card_number;
            list[i].cardItem = cardList[0];
            list[i].skuItem.price = 0;
          } else {
            list[i].cardId = "";
            list[i].cardItem = "";
          }
        }
        if (this.$public.isNull(list[i].activityId)) {
          list[i].activityId = "";
          list[i].activityItem = "";
        }
        if (this.$public.isNull(list[i].giftList)) {
          list[i].giftList = [];
        }
        if (this.$public.isNull(list[i].salesMans)) {
          list[i].salesMans = [];
        }
      }
      this.tableData = list;
      this.drwaerXimeiSelectedService_state = false;
      if (list.length > 0) {
        this.getActivityListByArr();
      }
    },
    delService(row, rowIndex) {
      console.log(row, rowIndex);
      this.$confirm("确定删除吗?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.tableData.splice(rowIndex, 1);
        this.$store.commit("jiyangguanli/set_ximeiList", this.tableData);
      });
    },
    // 补差价
    addDiffItem() {
      let table = this.tableData;
      for (let i = 0; i < table.length; i++) {
        if (table[i].serviceId === "605efaac8179d7f26789d010") {
          this.$message({
            message: "不能重复添加补差价项目",
            type: "error",
          });
          return;
        }
      }
      let obj = JSON.parse(JSON.stringify(this.$util.diffItem));
      this.tableData.push(obj);
      this.$store.commit("jiyangguanli/set_ximeiList", this.tableData);
    },
    changeNum(row) {
      row.skuItem.price = this.$public.replaceGoodsDosage(row.skuItem.price);
      row.skuItem.originalPrice = row.skuItem.price;
      this.$store.commit("jiyangguanli/set_ximeiList", this.tableData);
    },
    /////////////// 洗美卡
    changeCardId(row, rowIndex) {
      if (this.$public.isNull(row.cardId)) {
        console.log("取消洗美卡", row.skuItem);
        row.skuItem.price = row.skuItem.originalPrice;
        row.cardItem = {};
      } else {
        row.activityId = "";
        row.activityItem = {};
        row.skuItem.price = 0;
        row.cardItem = this.$public.getMatchingItem(
          row.cardList,
          "card_number",
          row.cardId
        );
      }
      this.$set(this.tableData, rowIndex, row);
      this.$store.commit("jiyangguanli/set_ximeiList", this.tableData);
    },
    getCardCanUsed(petId, serviceItem) {
      let arr = [];
      for (let i = 0; i < this.allCardList.length; i++) {
        let cardItem = this.allCardList[i];
        if (petId === cardItem.pet_id) {
          arr.push(cardItem);
        } else {
          let isWeight = false,
            isSpecial = false,
            isHair = false;
          let cardSpecial = 50,
            cardHair = 50;
          if (
            cardItem.pet_special !== "0" &&
            !this.$public.isNull(cardItem.pet_special)
          ) {
            cardSpecial = Number(cardItem.pet_special);
          }
          if (
            cardItem.pet_hair !== "0" &&
            !this.$public.isNull(cardItem.pet_hair)
          ) {
            cardHair = Number(cardItem.pet_hair);
          }
          if (cardSpecial >= Number(serviceItem.skuItem.apply_varieties.code)) {
            isSpecial = true;
          }
          if (cardHair >= Number(serviceItem.skuItem.apply_features.code)) {
            isHair = true;
          }
          if (
            cardItem.weight_max >= serviceItem.skuItem.weight_detail.max_weight
          ) {
            isWeight = true;
          }
          if (
            isWeight &&
            isSpecial &&
            isHair &&
            serviceItem.serviceId === cardItem.service_id
          ) {
            arr.push(cardItem);
          }
        }
      }
      return arr;
    },
    getAllCardsList() {
      let params = {
        memberId: this.userInfo._id,
        isvalid: 1, // 是否有效 0：不限、1：有效、2：无效
      };
      let loading = this.$loading();
      this.$http.get("/api/Member/BindCards", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.allCardList = res.data;
        }
      });
    },
    /////////////////// 活动
    changeActivityId(row, rowIndex) {
      if (this.$public.isNull(row.activityId)) {
        console.log("取消活动");
        row.skuItem.price = row.skuItem.originalPrice;
        row.activityItem = {};
        row.giftList = [];
      } else {
        row.activityItem = {};
        row.giftList = [];
        let activityItem = this.$public.getMatchingItem(
          row.activityList,
          "_id",
          row.activityId
        );
        let calcResult = this.$public.calcActivity(
          activityItem,
          this.$public.cheng(row.skuItem.originalPrice, 1),
          1
        );
        console.log(calcResult);
        row.skuItem.price = this.$public.chu(calcResult.newPrice, 1);
        row.activityItem = activityItem;
        if (!this.$public.isNull(calcResult.gift.give_list)) {
          row.giftList = calcResult.gift;
          // this.drawerGift_state = true;
        }
      }
      this.$set(this.tableData, rowIndex, row);
      this.$store.commit("jiyangguanli/set_ximeiList", this.tableData);
    },
    getActivityListByArr() {
      let arr = this.tableData;
      for (let i = 0; i < arr.length; i++) {
        arr[i].goodsId = arr[i].serviceId;
        arr[i].skus = arr[i].skuItem.service_objectId;
        arr[i].skuValue = arr[i].skuItem.service_objectName;
        arr[i].brand = "";
        arr[i].categoryId = arr[i].category_info._id;
        arr[i].unitId = "";
        arr[i].customCode = "";
      }
      this.$util
        .getActivityOfProduct(this.userInfo, arr, this.curPetInfo)
        .then((res) => {
          for (let i = 0; i < arr.length; i++) {
            arr[i].activityList = res[i].list;
            if (
              !this.$public.isNull(res[i].list) &&
              res[i].list[0].auto_matching > 0
            ) {
              if (this.$public.isNull(arr[i].activityId)) {
                if (this.$public.isNull(arr[i].cardId)) {
                  if (
                    this.$public.isNull(
                      this.curDiscountCard && this.curDiscountCard._no
                    )
                  ) {
                    arr[i].activityId = res[i].list[0]._id;
                    arr[i].activityItem = res[i].list[0];
                    let calcResult = this.$public.calcActivity(
                      arr[i].activityItem,
                      this.$public.cheng(arr[i].skuItem.originalPrice, 1),
                      1
                    );
                    console.log(calcResult);
                    arr[i].skuItem.price = this.$public.chu(
                      calcResult.newPrice,
                      1
                    );
                    if (!this.$public.isNull(calcResult.gift.give_list)) {
                      arr[i].giftList = calcResult.gift;
                      // this.drawerGift_state = true;
                    }
                  }
                }
              }
            }
            this.$set(this.tableData, i, arr[i]);
          }
          this.$store.commit("jiyangguanli/set_ximeiList", this.tableData);
        });
    },
    // 销售人员
    changeSaleManIdList(row, rowIndex) {
      if (this.$public.isNull(row.salesMans)) {
        console.log("取消销售人员");
      } else {
        console.log("改变销售人员");
      }
      if (rowIndex === 0) {
        for (let i = 0; i < this.tableData.length; i++) {
          this.tableData[i].salesMans = this.tableData[0].salesMans;
        }
      }
      this.$set(this.tableData, rowIndex, row);
      this.$store.commit("jiyangguanli/set_ximeiList", this.tableData);
    },
    getStaffList() {
      let params = {
        keyword: "",
        pageIndex: 1,
        pageSize: 500,
      };
      this.$http.get("/api/Staff/BathStaffList", params).then((res) => {
        if (res.code == 0) {
          this.staffList = res.data.data;
        }
      });
    },
    // 赠品
    // openGift(){
    // 	this.giveGoods.giftTableData = JSON.parse(JSON.stringify(this.giftTableData))
    // 	this.giveGoods.goodsTableData = JSON.parse(JSON.stringify(this.goodsTableData))
    // 	this.drawerGift_state=true
    // },
    // submit_drawerGift({giftTableData,goodsTableData}){
    // 	console.log(giftTableData,goodsTableData)
    // 	this.giftTableData = giftTableData
    // 	this.goodsTableData = goodsTableData
    // 	this.drawerGift_state = false;
    // 	this.addParams.giftTableData = this.giftTableData
    // 	this.addParams.goodsTableData = this.goodsTableData
    // 	this.$store.commit('jiyangguanli/set_ximeiList',this.addParams)
    // },
    // 备注
    changeRemark() {
      this.$store.commit("jiyangguanli/set_ximeiList", this.tableData);
      this.$store.commit("jiyangguanli/set_ximeiRemark", this.remark);
    },
  },
};
</script>

<style scoped lang="scss">
.drawer {
  width: 0;
  padding: 0 0 0 0;
  ::v-deep.el-drawer {
    .el-drawer__header {
      margin-bottom: 10px;
    }
    .el-drawer__body {
      height: 100%;
      overflow-y: auto;
      padding-bottom: 100px;
      padding-bottom: 65px;
      box-sizing: border-box;
      height: 100%;
      position: relative;
      .titleLine {
        position: absolute;
        z-index: 1;
        width: 100%;
        background-color: #fff;
        height: 48px;
        padding: 12px 10px 8px 10px;
        box-sizing: border-box;
        .taskBox {
          display: flex;
          padding-top: 4px;
          .taskItem {
            display: flex;
            align-items: center;
            padding: 0 20px;
            border-right: 2px solid #f5f5f5;
            cursor: pointer;
            &:last-child {
              border-right: 0;
            }
            .taskNum {
              font-size: 12px;
              color: #fff;
              margin-right: 4px;
              background-color: #ff182a;
              border-radius: 50%;
              width: 20px;
              line-height: 20px;
              text-align: center;
            }
            .taskText {
              font-size: 14px;
              color: #1890ff;
              padding-right: 4px;
            }
            .taskNext {
              width: 4px;
              height: 7px;
            }
          }
        }
      }
      .tableBox {
        height: 100%;
        padding-top: 48px;
        box-sizing: border-box;
      }
      .btn_operate {
        width: 10px;
        height: 10px;
        padding-right: 5px;
        cursor: pointer;
      }
    }
  }
}
</style>
